var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","dir":_vm.$i18n.locale === 'ar' ? 'rtl' : 'ltr'}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }